import { Info } from "lucide-react";
import { PreferenceItemProps } from "./types";

const PreferenceItem = ({
  label,
  children,
  tooltip,
  fieldName,
  errors,
}: PreferenceItemProps) => (
  <div className="space-y-2">
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        <label className="text-sm font-medium">{label}</label>
        {tooltip && (
          <div className="relative group">
            <Info className="w-4 h-4 text-gray-400" />
            <div className="absolute left-full ml-2 w-48 p-2 bg-gray-800 text-white text-xs rounded hidden group-hover:block">
              {tooltip}
            </div>
          </div>
        )}
      </div>
    </div>
    <div
      className={`${errors?.find((e) => e.field === fieldName)
        ? "border border-red-500 rounded-md"
        : ""
        }`}
    >
      {children}
    </div>
    {errors?.find((e) => e.field === fieldName) && (
      <div className="text-sm text-red-500 mt-1">
        {errors.find((e) => e.field === fieldName)?.message}
      </div>
    )}
  </div>
);

export default PreferenceItem;